'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_samples$002e$002dPersons$0024package$0024$002dHouse$00242 from "./samples.-Persons$package$-House$2.js";
var $p;
/** @constructor */
function $c_Lsamples_Persons$package$$anon$7$$anon$15(evaluator$25) {
  this.LL = null;
  this.LL = evaluator$25;
}
export { $c_Lsamples_Persons$package$$anon$7$$anon$15 as $c_Lsamples_Persons$package$$anon$7$$anon$15 };
$p = $c_Lsamples_Persons$package$$anon$7$$anon$15.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_Persons$package$$anon$7$$anon$15;
/** @constructor */
function $h_Lsamples_Persons$package$$anon$7$$anon$15() {
}
export { $h_Lsamples_Persons$package$$anon$7$$anon$15 as $h_Lsamples_Persons$package$$anon$7$$anon$15 };
$h_Lsamples_Persons$package$$anon$7$$anon$15.prototype = $p;
$p.b = (function() {
  return "<function0>";
});
$p.v = (function() {
  var v = this.LL.h();
  return ((v instanceof $j_samples$002e$002dPersons$0024package$0024$002dHouse$00242.$c_Lsamples_Persons$package$House$2) ? new $j_java$002elang$002e$002dObject.$c_s_Some(v) : $j_java$002elang$002e$002dObject.$m_s_None$());
});
$p.h = (function() {
  return this.v();
});
var $d_Lsamples_Persons$package$$anon$7$$anon$15 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_Persons$package$$anon$7$$anon$15, "samples.Persons$package$$anon$7$$anon$15", ({
  q3: 1,
  d: 1,
  a: 1,
  f: 1
}));
export { $d_Lsamples_Persons$package$$anon$7$$anon$15 as $d_Lsamples_Persons$package$$anon$7$$anon$15 };
